import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useStaticQuery, graphql } from "gatsby"

import CTABtnModule from "gatsby-theme-starberry-lomondgroup/src/modules/cta_btn_module";
import ContentModule from "gatsby-theme-starberry-lomondgroup/src/modules/content_module";
import {ScrollToDiv} from "gatsby-theme-starberry-lomondgroup/src/common/utils/site_utlis";

import "gatsby-theme-starberry-lomondgroup/src/components/GuidesListBanner/GuidesListBanner.scss";
const GuidesListBanner = () => {

    const data = useStaticQuery(graphql`
    query GuidesBannerQueryCustom {
        glstrapi {
            globalModule {
                guides_banner  {
                    title
                    content
                    button_cta_1 {
                        theme
                        label
                        id
                        custom_link
                        target
                        menu_item {
                            slug
                            parent {
                                slug
                                parent {
                                    slug
                                    parent {
                                        slug
                                    }
                                }
                            }
                        }
                    }
                    button_cta_2 {
                        theme
                        label
                        id
                        custom_link
                        target
                        menu_item {
                            slug
                            parent {
                                slug
                                parent {
                                    slug
                                    parent {
                                        slug
                                    }
                                }
                            }
                        }
                    }
                }      
            }
        }
    }`)

    var global_data = data?.glstrapi?.globalModule.guides_banner;

    return (
        <React.Fragment>
            {(global_data?.title || global_data?.content) && 
                <section className={`landing-page-banner`}>
                    <Row>
                        <Col>
                            <div className="page-banner-inner">
                                <div className="page-banner-content">
                                    <h3>{global_data?.title}</h3>
                                    {global_data?.content && <ContentModule Content={`<p>${global_data?.content}</p>`}/> }
                                </div>
                                <div className="btn-wrapper">
                                    {global_data?.button_cta_1 && global_data?.button_cta_1.label && (
                                    (global_data?.button_cta_1.label).toLowerCase() === "subscribe" ?
                                        <a href="javascript:;" onClick={()=>ScrollToDiv("footer_subscribe")} className={`btn btn-primary`}>  
                                            {global_data?.button_cta_1.label}
                                        </a>
                                    :
                                        <CTABtnModule button_cta={global_data?.button_cta_1} />
                                    )
                                    }
                                    {global_data?.button_cta_2 && global_data?.button_cta_2.label && <CTABtnModule button_cta={global_data?.button_cta_2} /> }
                                </div>
                            </div>
                        </Col>
                    </Row>
                </section>
            }
        </React.Fragment>
    );

};

export default GuidesListBanner;
